import { ConnectDragPreview, ConnectDragSource, useDrag } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { DragSourceType } from 'const';
import { toggleDragState } from 'containers/App/actions';

type SSIDragSourceHook = {
  dragRef: ConnectDragSource;
  preview: ConnectDragPreview;
};

export const useSSIDragSource = (): SSIDragSourceHook => {
  const dispatch = useDispatch();
  const dragSourceType = DragSourceType.ARTBOARD_SSI;
  const [, dragRef, preview] = useDrag<object, void, void>({
    type: dragSourceType,
    item: () => {
      dispatch(toggleDragState(dragSourceType));

      return {};
    },
    end: () => {
      dispatch(toggleDragState());
    },
  });

  return { dragRef, preview };
};
